import { logger } from '@/utils/logger';

import { supabase } from '@/integrations/supabase/client';
import { getCurrentUserOrganizationId } from './tenantUtils';

export const getUserOrganization = async (userId?: string) => {
  try {
    const organizationId = await getCurrentUserOrganizationId();

    const { data: organization, error } = await supabase
      .from('organizations')
      .select('id, name, code, subdomain')
      .eq('id', organizationId)
      .single();

    if (error) {
      throw error;
    }

    return organization;
  } catch (error) {
    logger.error('Error getting user organization:', error);
    throw error;
  }
};

/**
 * Gets the current user's organization using the tenant utility
 */
export const getCurrentUserOrganization = async () => {
  const organizationId = await getCurrentUserOrganizationId();
  
  const { data: organization, error } = await supabase
    .from('organizations')
    .select('*')
    .eq('id', organizationId)
    .single();

  if (error) {
    throw new Error(`Failed to get organization: ${error.message}`);
  }

  return organization;
};

export const verifyOrganization = async (code: string) => {
  logger.debug('Verifying organization with code:', code);
  
  try {
    // Use the public view which has anon access for login verification
    const { data: organization, error } = await supabase
      .from('v_organizations_public')
      .select('*')
      .eq('code', code.toLowerCase())
      .maybeSingle();

    logger.debug('Organization query result:', { organization, error });

    if (error) {
      logger.error('Database error:', error);
      throw new Error('Error verifying organization: ' + error.message);
    }

    if (!organization) {
      logger.debug('No organization found for code:', code);
      throw new Error('Organization not found or inactive');
    }

    logger.debug('Organization verified successfully:', organization);
    return organization;
  } catch (error: any) {
    logger.error('Verification error:', error);
    throw new Error(error.message || 'Invalid organization code');
  }
};
